import { CIcon } from '~/icons/types'

export const ciVehicles: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.05 10.356a1.423 1.423 0 0 0 1.4-1.5 1.42 1.42 0 0 0-1.4-1.5h-1.711l-.621-1.474a2.564 2.564 0 0 0-2.368-1.625H7.912a2.6 2.6 0 0 0-2.523 1.6l-.628 1.499h-1.81a1.421 1.421 0 0 0-1.4 1.5 1.421 1.421 0 0 0 1.4 1.5h.181a3.555 3.555 0 0 0-.981 2.5v3.5a.5.5 0 0 0 .382.485l.017.005v1.41a1.4 1.4 0 0 0 1.4 1.4h1.4a1.4 1.4 0 0 0 1.4-1.4v-.5h10.6v.6a1.4 1.4 0 0 0 1.4 1.4h1.4a1.4 1.4 0 0 0 1.4-1.4v-1.5a.5.5 0 0 0 .5-.5v-3.5a3.744 3.744 0 0 0-1.017-2.5h.017Zm0-2c.24 0 .4.2.4.5s-.16.5-.4.5h-.869l-.421-1h1.29ZM6.3 6.28a1.659 1.659 0 0 1 1.55-1.024h8.5a1.557 1.557 0 0 1 1.44 1l1.349 3.206H4.961L6.3 6.28ZM2.951 9.356c-.24 0-.4-.2-.4-.5s.161-.5.4-.5H4.34l-.421 1h-.968Zm.2 3.9h1.876l.45 1H3.151v-1Zm2.6 5a.4.4 0 0 1-.4.4h-1.4a.4.4 0 0 1-.4-.4V17.09l2.2.535v.63Zm14.8.1a.4.4 0 0 1-.4.4h-1.4a.4.4 0 0 1-.4-.4v-.73l2.2-.535v1.265Zm.5-2.415-3.359.816H6.41l-3.259-.793v-.706h3.1a.5.5 0 0 0 .457-.7l-.9-2a.5.5 0 0 0-.456-.295H3.214a2.473 2.473 0 0 1 .949-1.51l.363-.29h15.149l.35.279c.47.394.802.926.952 1.52H18.75a.5.5 0 0 0-.456.296l-.9 2a.5.5 0 0 0 .456.705h3.2l.001.678Zm0-2.683v1h-2.427l.45-1h1.977Z'
    },
    {
      d:
        'M15.95 12.758h-7.8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h7.8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5Zm-.5 2h-6.8v-1h6.8v1Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'vehicles',
  type: 'thin'
}
